import type { FC, ImgHTMLAttributes, SyntheticEvent } from 'react';
import { buildSrcSet } from '../../utils/responsiveImage';
import { markImageLoaded, markImageError } from '../../utils/markImageSettled';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'srcSet'> & {
  src: string;
  sizes: string;
  originalWidth: number;
};

export const ResponsiveImage: FC<Props> = ({ src, sizes, originalWidth, ...imgProps }) => {
  const avifSrcSet = buildSrcSet(src, 'avif', originalWidth);
  const webpSrcSet = buildSrcSet(src, 'webp', originalWidth);

  const handleLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    markImageLoaded(e);
    imgProps.onLoad?.(e);
  };

  const handleError = (e: SyntheticEvent<HTMLImageElement>) => {
    markImageError(e);
    imgProps.onError?.(e);
  };

  if (!avifSrcSet || !webpSrcSet) {
    return <img src={src} {...imgProps} onLoad={handleLoad} onError={handleError} />;
  }

  return (
    <picture>
      <source type="image/avif" srcSet={avifSrcSet} sizes={sizes} />
      <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      <img src={src} sizes={sizes} {...imgProps} onLoad={handleLoad} onError={handleError} />
    </picture>
  );
};
